import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons from '../../components/ActionButtons';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

const ESIK_TIPLERI = [
  { value: 'YUZDE', label: 'Doluluk Yüzdesi (%)', aciklama: 'Toplam odaların bu kadar yüzdesi dolduğunda' },
  { value: 'SAYI', label: 'Kalan Oda Sayısı', aciklama: 'Bu kadar veya daha az oda kaldığında' },
];

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

// ── Saat Bazlı Kural Modal ─────────────────────────────────────
function SaatKuralModal({ kural, odaTipleri, onKapat, onKaydedildi }) {
  const yeni = !kural?.saatFiyatKuraliId;
  const [form, setForm] = useState({
    odaTipiId: kural?.odaTipiId ?? '',
    baslangicSaati: kural?.baslangicSaati ?? '22:00',
    bitisSaati: kural?.bitisSaati ?? '06:00',
    artisYuzde: kural?.artisYuzde ?? '',
    aciklama: kural?.aciklama ?? '',
    aktifMi: kural?.aktifMi ?? true,
  });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${
      hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (!form.baslangicSaati || !form.bitisSaati || form.artisYuzde === '') { setHata('Saat aralığı ve değişim yüzdesi zorunludur.'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const payload = { odaTipiId: form.odaTipiId ? parseInt(form.odaTipiId) : null, baslangicSaati: form.baslangicSaati, bitisSaati: form.bitisSaati, artisYuzde: parseFloat(form.artisYuzde), aciklama: form.aciklama, aktifMi: form.aktifMi };
      if (kural?.saatFiyatKuraliId) await apiRequest(`saatfiyat/${kural.saatFiyatKuraliId}`, 'PUT', payload);
      else await apiRequest('saatfiyat', 'POST', payload);
      onKaydedildi(); onKapat();
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-0 lg:p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
      <div className="bg-white w-full max-w-xl rounded-none lg:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden border border-white/20 animate-scale-in">
        {/* Modal Header */}
        <div className="relative flex items-center justify-between px-8 py-7 bg-gradient-to-r from-indigo-600 to-blue-700 overflow-hidden leading-none">
          <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none transform-gpu"></div>
          <div className="relative flex items-center gap-4 text-left leading-none">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-2xl shadow-inner border border-white/30 font-black">🕐</div>
            <div>
              <h2 className="text-white font-black text-lg tracking-tight uppercase leading-none">{yeni ? 'Yeni Saat Kuralı' : 'Saat Kuralı Düzenle'}</h2>
              <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest mt-1.5 opacity-80 leading-none">Giriş saatine bağlı dinamik fiyat değişimi</p>
            </div>
          </div>
          <button onClick={onKapat} className="relative z-10 text-white/60 hover:text-white w-10 h-10 flex items-center justify-center rounded-xl hover:bg-white/10 transition-all text-xl leading-none">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-6 no-scrollbar leading-none text-left">
          {hata && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata}</div>}

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KAPSAM / ODA TİPİ</label>
            <select value={form.odaTipiId} onChange={e => set('odaTipiId', e.target.value)} className={INP(false) + ' cursor-pointer'}>
              <option value="">TÜM ODA TİPLERİ</option>
              {odaTipleri.map(t => <option key={t.odaTipiId} value={t.odaTipiId}>{t.ad}</option>)}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-6 text-left">
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">BAŞLANGIÇ SAATİ</label>
              <input type="time" value={form.baslangicSaati} onChange={e => set('baslangicSaati', e.target.value)} className={INP(false)} />
            </div>
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">BİTİŞ SAATİ</label>
              <input type="time" value={form.bitisSaati} onChange={e => set('bitisSaati', e.target.value)} className={INP(false)} />
            </div>
          </div>

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">FİYAT DEĞİŞİMİ (%)</label>
            <div className="relative">
              <input type="number" value={form.artisYuzde} onChange={e => set('artisYuzde', e.target.value)}
                className={INP(false) + ' pr-12 text-center text-lg'} placeholder="Örn: 15 veya -20" />
              <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">%</span>
            </div>
          </div>

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KISA AÇIKLAMA</label>
            <textarea value={form.aciklama} onChange={e => set('aciklama', e.target.value)} className={INP(false) + ' resize-none'} placeholder="Örn: Gece geç giriş indirimi..." />
          </div>
        </div>

        <div className="px-8 py-6 flex gap-4 justify-end border-t border-gray-50 bg-gray-50/50">
          <button onClick={onKapat} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-indigo-600 to-blue-700 hover:from-indigo-700 hover:to-blue-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-indigo-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase leading-none">
            {kaydediliyor ? '⌛ KAYIT...' : '💾 KURALI KAYDET'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Doluluk Bazlı Kural Modal ───────────────────────────────────
function KuralModal({ kural, odaTipleri, onKapat, onKaydedildi }) {
  const yeni = !kural?.dolulukFiyatKuraliId;
  const [form, setForm] = useState({ odaTipiId: kural?.odaTipiId ?? '', esikTipi: kural?.esikTipi ?? 'YUZDE', esikDeger: kural?.esikDeger ?? '', artisYuzde: kural?.artisYuzde ?? '', aciklama: kural?.aciklama ?? '', aktifMi: kural?.aktifMi ?? true });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${
      hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-orange-400 focus:ring-4 focus:ring-orange-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (form.esikDeger === '' || form.artisYuzde === '') { setHata('Tüm alanları doldurunuz.'); return; }
    setKaydediliyor(true); setHata('');
    try {
      const payload = { odaTipiId: form.odaTipiId ? parseInt(form.odaTipiId) : null, esikTipi: form.esikTipi, esikDeger: parseFloat(form.esikDeger), artisYuzde: parseFloat(form.artisYuzde), aciklama: form.aciklama, aktifMi: form.aktifMi };
      if (kural?.dolulukFiyatKuraliId) await apiRequest(`dolulukfiyat/${kural.dolulukFiyatKuraliId}`, 'PUT', payload);
      else await apiRequest('dolulukfiyat', 'POST', payload);
      onKaydedildi(); onKapat();
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-0 lg:p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
      <div className="bg-white w-full max-w-xl rounded-none lg:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden border border-white/20 animate-scale-in">
        <div className="relative flex items-center justify-between px-8 py-7 bg-gradient-to-r from-orange-600 to-amber-600 overflow-hidden text-white leading-none">
          <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none transform-gpu"></div>
          <div className="relative flex items-center gap-4 text-left leading-none font-black text-2xl uppercase">📈</div>
          <div className="flex-1 text-left leading-none">
             <h2 className="text-white font-black text-lg tracking-tight uppercase leading-none">{yeni ? 'Yeni Doluluk Kuralı' : 'Doluluk Kuralı Düzenle'}</h2>
             <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest mt-1.5 opacity-80 leading-none">Talep bazlı dinamik fiyat güncellemeleri</p>
          </div>
          <button onClick={onKapat} className="relative z-10 text-white/60 hover:text-white w-10 h-10 flex items-center justify-center rounded-xl hover:bg-white/10 transition-all text-xl leading-none">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-6 no-scrollbar leading-none text-left">
          {hata && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata}</div>}

          <div className="text-left text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KAPSAM / ODA TİPİ</label>
            <select value={form.odaTipiId} onChange={e => set('odaTipiId', e.target.value)} className={INP(false) + ' cursor-pointer'}>
              <option value="">TÜM ODA TİPLERİ</option>
              {odaTipleri.map(t => <option key={t.odaTipiId} value={t.odaTipiId}>{t.ad}</option>)}
            </select>
          </div>

          <div className="text-left select-none">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-4 ml-1">TETİKLEYİCİ EŞİK TİPİ</label>
            <div className="grid grid-cols-2 gap-4">
              {ESIK_TIPLERI.map(e => (
                <button type="button" key={e.value} onClick={() => set('esikTipi', e.value)}
                  className={`px-4 py-6 rounded-[2rem] text-[10px] font-black border-2 transition-all duration-300 flex flex-col items-center justify-center text-center uppercase tracking-[0.1em] leading-relaxed transform-gpu active:scale-95 ${form.esikTipi === e.value ? 'border-orange-500 bg-orange-600 text-white shadow-xl shadow-orange-100 scale-[1.03]' : 'border-gray-50 text-gray-400 bg-gray-50/50 hover:border-orange-100'}`}>
                  <span className="mb-2 text-base font-black leading-none">{form.esikTipi === e.value ? '✓' : '○'}</span>
                  <span className="leading-tight">{e.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 leading-none text-left">
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1 uppercase">{form.esikTipi === 'YUZDE' ? 'DOLULUK % EŞİĞİ' : 'KALAN ODA SAYISI'}</label>
              <input type="number" value={form.esikDeger} onChange={e => set('esikDeger', e.target.value)} className={INP(false) + ' text-center text-lg'} placeholder={form.esikTipi === 'YUZDE' ? 'Örn: 80' : 'Örn: 5'} />
            </div>
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1 uppercase">FİYAT ARTIŞI (%)</label>
              <div className="relative">
                <input type="number" value={form.artisYuzde} onChange={e => set('artisYuzde', e.target.value)} className={INP(false) + ' text-center text-lg pr-12'} />
                <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-8 py-6 flex gap-4 justify-end border-t border-gray-50 bg-gray-50/50 leading-none">
          <button onClick={onKapat} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-orange-100 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase leading-none">
            {kaydediliyor ? '⌛ KAYIT...' : '💾 KURALI KAYDET'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function DolulukFiyatKurallari() {
  const [kurallar, setKurallar] = useState([]);
  const [saatKurallari, setSaatKurallari] = useState([]);
  const [odaTipleri, setOdaTipleri] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [saatModal, setSaatModal] = useState(null);
  const [saatSilOnay, setSaatSilOnay] = useState(null);

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    try {
      const [k, t, s] = await Promise.all([apiRequest('dolulukfiyat'), apiRequest('OdaTipi'), apiRequest('saatfiyat')]);
      setKurallar(k || []); setOdaTipleri(t || []); setSaatKurallari(s || []);
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  async function handleSil(id) { await apiRequest(`dolulukfiyat/${id}`, 'DELETE'); setSilOnay(null); yukle(); }
  async function handleSaatSil(id) { await apiRequest(`saatfiyat/${id}`, 'DELETE'); setSaatSilOnay(null); yukle(); }

  return (
    <div className="p-3 md:p-6 space-y-8 min-h-screen bg-gray-50/50 animate-fadeIn leading-none" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="📈"
        iconColor="from-orange-600 to-amber-700"
        iconShadow="shadow-orange-200"
        title="Dinamik Fiyatlandırma"
        subtitle="Otomatik doluluk ve saat bazlı fiyat yönetimi"
      >
        <div className="flex flex-wrap md:flex-nowrap gap-3 w-full md:w-auto leading-none">
          <button onClick={() => setModal('yeni')}
            className="flex-1 md:flex-none group flex items-center justify-center gap-3 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700 text-white px-8 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-orange-200 transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest whitespace-nowrap leading-none relative overflow-hidden">
            <span className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
            <span className="relative text-xl leading-none">＋</span> <span className="relative leading-none">KURAL EKLE</span>
          </button>
          <button onClick={() => setSaatModal('yeni')}
            className="flex-1 md:flex-none group flex items-center justify-center gap-3 bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-indigo-100 transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest whitespace-nowrap leading-none relative overflow-hidden">
            <span className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
            <span className="relative text-lg leading-none">🕐</span> <span className="relative leading-none">SAAT KURALI</span>
          </button>
        </div>
      </PageHeader>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 text-left leading-none">
        {/* DOLULUK KURALLARI */}
        <div className="space-y-6 leading-none animate-slide-up">
          <div className="flex items-center gap-4 px-2 leading-none">
            <div className="w-10 h-10 bg-orange-600 text-white rounded-xl flex items-center justify-center shadow-lg shadow-orange-100 font-black leading-none text-xl">🔥</div>
            <h2 className="text-xl font-black text-gray-800 tracking-tight uppercase leading-none">Doluluk Bazlı Kurallar</h2>
          </div>
          <div className="bg-white rounded-[3rem] border border-gray-100 shadow-xl overflow-hidden min-h-[400px] leading-none">
            {yukleniyor ? (
              <LoadingSpinner fullPage text="Sistem Kayıtları Okunuyor..." />
            ) : kurallar.length === 0 ? (
              <EmptyState icon="📈" text="Henüz doluluk kuralı tanımlanmamış" />
            ) : (
              <div className="p-4 md:p-8 space-y-5 leading-none">
                {kurallar.map(k => (
                  <div key={k.dolulukFiyatKuraliId} className="group relative bg-gray-50/50 hover:bg-orange-50/40 border-2 border-gray-50 hover:border-orange-100 rounded-[2.5rem] p-6 transition-all duration-300 transform-gpu shadow-sm hover:-translate-y-1">
                    <div className="flex items-start justify-between gap-6 mb-6 leading-none">
                      <div className="min-w-0 flex-1 leading-none text-left">
                        <p className="text-[9px] font-black text-orange-400 uppercase tracking-widest mb-1.5 opacity-60 leading-none truncate">{k.odaTipiAd || 'TÜM ODA TİPLERİ'}</p>
                        <h3 className="font-black text-gray-700 text-lg uppercase tracking-tight leading-none break-words leading-tight">
                          {k.esikTipi === 'YUZDE' ? `DOLULUK %${k.esikDeger} ULAŞTIĞINDA` : `KALAN ODA ${k.esikDeger}'E DÜŞTÜĞÜNDE`}
                        </h3>
                      </div>
                      <div className={`px-4 py-3 rounded-2xl font-black text-lg shadow-inner flex-shrink-0 transform-gpu group-hover:scale-110 transition-transform leading-none ${k.artisYuzde < 0 ? 'bg-blue-100 text-blue-600' : 'bg-orange-100 text-orange-700'}`}>
                        {k.artisYuzde > 0 ? '+' : ''}{k.artisYuzde}%
                      </div>
                    </div>
                    <div className="flex items-center justify-between border-t border-gray-100/50 pt-5 gap-3 leading-none">
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider truncate flex-1 opacity-70 leading-none">{k.aciklama || 'SİSTEM OPERASYON KURALI'}</p>
                      <ActionButtons onEdit={() => setModal(k)} onDelete={() => setSilOnay(k.dolulukFiyatKuraliId)} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* SAAT KURALLARI */}
        <div className="space-y-6 leading-none animate-slide-up" style={{ animationDelay: '0.1s' }}>
          <div className="flex items-center gap-4 px-2 leading-none">
            <div className="w-10 h-10 bg-indigo-600 text-white rounded-xl flex items-center justify-center shadow-lg shadow-indigo-100 font-black leading-none text-xl">🕐</div>
            <h2 className="text-xl font-black text-gray-800 tracking-tight uppercase leading-none">Saat Bazlı Kurallar</h2>
          </div>
          <div className="bg-white rounded-[3rem] border border-gray-100 shadow-xl overflow-hidden min-h-[400px] leading-none">
            {yukleniyor ? (
              <LoadingSpinner fullPage text="Sistem Kayıtları Okunuyor..." />
            ) : saatKurallari.length === 0 ? (
              <EmptyState icon="🕒" text="Henüz saat kuralı tanımlanmamış" />
            ) : (
              <div className="p-4 md:p-8 space-y-5 leading-none">
                {saatKurallari.map(k => (
                  <div key={k.saatFiyatKuraliId} className="group relative bg-gray-50/50 hover:bg-indigo-50/40 border-2 border-gray-50 hover:border-indigo-100 rounded-[2.5rem] p-6 transition-all duration-300 transform-gpu shadow-sm hover:-translate-y-1 leading-none text-left">
                    <div className="flex items-start justify-between gap-6 mb-6 leading-none">
                      <div className="min-w-0 flex-1 leading-none">
                        <p className="text-[9px] font-black text-indigo-400 uppercase tracking-widest mb-1.5 opacity-60 leading-none truncate">{k.odaTipiAd || 'TÜM ODA TİPLERİ'}</p>
                        <h3 className="font-black text-gray-700 text-lg uppercase tracking-tight leading-none break-words leading-tight flex items-center gap-2">
                           {k.baslangicSaati} <span className="text-indigo-300 font-black">➔</span> {k.bitisSaati} ARASI
                        </h3>
                      </div>
                      <div className={`px-4 py-3 rounded-2xl font-black text-lg shadow-inner flex-shrink-0 transform-gpu group-hover:scale-110 transition-transform leading-none ${k.artisYuzde < 0 ? 'bg-blue-100 text-blue-600' : 'bg-red-100 text-red-700'}`}>
                        {k.artisYuzde > 0 ? '+' : ''}{k.artisYuzde}%
                      </div>
                    </div>
                    <div className="flex items-center justify-between border-t border-gray-100/50 pt-5 gap-3 leading-none">
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider truncate flex-1 opacity-70 leading-none italic">{k.aciklama || 'GECE GEÇ GİRİŞ POLİTİKASI'}</p>
                      <ActionButtons onEdit={() => setSaatModal(k)} onDelete={() => setSaatSilOnay(k.saatFiyatKuraliId)} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <UsageInfo
        color="orange"
        description="Dinamik Fiyatlandırma modülü, doluluk oranına veya giriş saatine göre oda fiyatlarını otomatik kurgulayarak kar marjınızı maksimize eder."
        scenarios={[
          { title: "Doluluk Bazlı Artış", content: "Doluluk %80'i geçtiğinde fiyatları %20 artırarak son odaları maksimum karlılıkla satabilirsiniz." },
          { title: "Kalan Oda Takibi", content: "Son 3 oda kaldığında fiyatlara sabit bir 'Last-Chance' artışı uygulayabilirsiniz." },
          { title: "Gece Geç Giriş İndirimi", content: "Saat 22:00'den sabah 06:00'ya kadar olan 'Walk-in' girişler için özel bir indirim tanımlayarak boş oda kaybını önleyebilirsiniz." }
        ]}
      />

      {modal !== null && createPortal(
        <KuralModal kural={modal === 'yeni' ? null : modal} odaTipleri={odaTipleri} onKapat={() => setModal(null)} onKaydedildi={yukle} />,
        document.body
      )}

      {saatModal !== null && createPortal(
        <SaatKuralModal kural={saatModal === 'yeni' ? null : saatModal} odaTipleri={odaTipleri} onKapat={() => setSaatModal(null)} onKaydedildi={yukle} />,
        document.body
      )}

      {(silOnay || saatSilOnay) && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none font-black uppercase text-center">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm border border-gray-100 leading-none">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight leading-none">Kuralı Sil</h3>
            <p className="text-[11px] font-black text-gray-400 mt-5 mb-10 leading-relaxed uppercase tracking-tight leading-loose italic">Bu kural kalıcı olarak silinecek ve aktif fiyatlandırma motorundan çıkarılacak. Emin misiniz?</p>
            <div className="flex gap-4 leading-none">
              <button onClick={() => { setSilOnay(null); setSaatSilOnay(null); }} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
              <button onClick={() => silOnay ? handleSil(silOnay) : handleSaatSil(saatSilOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-100 transition-all uppercase tracking-widest transform-gpu active:scale-95 leading-none font-black text-lg">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        .animate-slide-up { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}
